import { Tag } from '@scale/scaleui';
import { numberToDollars } from 'react-scale/components/scalers/tasks/OutlierTaskHeader/utils';

export const ChipAssessmentBonus = ({
  assessmentBonus,
}: {
  assessmentBonus: number | undefined;
}) => {
  if (!assessmentBonus) {
    return null;
  }

  return (
    <Tag title="Assessment Reward" className="mx-2">
      {'Reward for passing: ' + numberToDollars(assessmentBonus)}
    </Tag>
  );
};
